export default {
  'menu.welcome': 'Bem-vindo',
  'menu.home': 'Início',
  'menu.login': 'Login',

  // Módulo de Gerenciamento do Sistema
  'menu.system': 'Gerenciamento do Sistema',
  'menu.system.welcome': 'Página Inicial do Sistema',
  'menu.system.dict': 'Gerenciamento de Dicionário',
  'menu.system.menu': 'Gerenciamento de Menu',
  'menu.system.role': 'Gerenciamento de Função',
  'menu.system.noAuth': 'Interface Sem Autenticação',

  // Módulo de Gerenciamento de Eventos
  'menu.event': 'Gerenciamento de Eventos',
  'menu.event.eventRecord': 'Registro de Eventos',
  'menu.event.eventOrder': 'Ordem de Eventos',
  'menu.event.eventOrderNode': 'Nó da Ordem',
  'menu.event.eventReceiver': 'Receptor de Eventos',
  'menu.event.resourceFile': 'Arquivo de Recursos',

  // Módulo de Gerenciamento Organizacional
  'menu.organization': 'Gerenciamento Organizacional',
  'menu.organization.orgDept': 'Gerenciamento de Departamento',
  'menu.organization.orgPost': 'Gerenciamento de Cargo',
  'menu.organization.orgTree': 'Estrutura Organizacional',
  'menu.organization.employee': 'Gerenciamento de Funcionários',

  // Módulo de Gerenciamento de Dispositivos
  'menu.device': 'Gerenciamento de Dispositivos',
  'menu.device.deviceModel': 'Modelo de Dispositivo',
  'menu.device.deviceSupplier': 'Fornecedor de Dispositivos',
  'menu.device.deviceGateway': 'Gateway de Dispositivos',
  'menu.device.deviceTerminal': 'Terminal de Dispositivos',
  'menu.device.deviceManagement': 'Gerenciamento de Dispositivos',

  // Módulo de Gerenciamento de Pacotes
  'menu.package': 'Gerenciamento de Pacotes',
  'menu.package.myPackage': 'Meus Pacotes',
  'menu.package.subPackage': 'Pacotes Filhos',

  // Gerenciamento de Usuários
  'menu.user': 'Gerenciamento de Usuários',

  // Módulo de Fusão de Vídeo
  'menu.video': 'Fusão de Vídeo',
  'menu.video.preview': 'Pré-visualização em Tempo Real',
  'menu.video.playback': 'Reprodução de Histórico',
  'menu.video.recording': 'Gravação Manual',
};
